export default __webpack_public_path__ + "static/project-start1-54b3c42247bc79bd9f686199e126e81a.svg";